import { useTranslation } from 'react-i18next';

const RejectModal = ({ open, onClose, onConfirm, loading }) => {
  const { t } = useTranslation();

  if (!open) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    const reason = e.target.rejectionReason.value.trim();
    if (reason) onConfirm(reason);
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 p-4">
      <div className="w-full max-w-md rounded-xl border border-zinc-200 dark:border-zinc-800 bg-white dark:bg-zinc-900 p-6">
        <h3 className="text-lg font-medium">{t('admin.rejectModal.title')}</h3>
        <p className="mt-1 text-sm text-zinc-600 dark:text-zinc-500">{t('admin.rejectModal.subtitle')}</p>
        <form onSubmit={handleSubmit} className="mt-4 space-y-4">
          <textarea
            name="rejectionReason"
            rows={4}
            required
            placeholder={t('admin.rejectModal.placeholder')}
            className="w-full rounded-lg border border-zinc-300 dark:border-zinc-700 bg-zinc-50 dark:bg-zinc-950 px-3 py-2 text-sm outline-none focus:border-glow-500"
          />
          <div className="flex justify-end gap-3">
            <button type="button" onClick={onClose} className="rounded-lg px-4 py-2 text-sm text-zinc-600 dark:text-zinc-400 hover:text-zinc-900 dark:hover:text-white">
              {t('common.cancel')}
            </button>
            <button
              type="submit"
              disabled={loading}
              className="rounded-lg bg-red-600 px-4 py-2 text-sm font-medium text-white hover:bg-red-500 disabled:opacity-50"
            >
              {loading ? t('admin.rejectModal.rejecting') : t('admin.rejectModal.confirmReject')}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default RejectModal;
